<div class="confirmation-dialog">
  <h2 mat-dialog-title class="dialog-title">
    <mat-icon class="dialog-icon" [class.dangerous]="data.isDangerous">
      {{ data.icon }}
    </mat-icon>
    {{ data.title }}
  </h2>

  <mat-dialog-content class="dialog-content">
    <p>{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-button">
      {{ data.cancelText }}
    </button>
    <button
      mat-raised-button
      [color]="data.isDangerous ? 'warn' : 'primary'"
      (click)="onConfirm()"
      class="confirm-button"
    >
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
